import React from 'react';
import { Copy, Stack } from '@grubhubprod/gh-cookbook-react';

export const ReportDateRangeTooltipContent: React.FC = () => (
  <Copy variant="body" color="invertedPrimaryText">
    <Stack as="ul">
      <Stack as="li" y="xx-sm">
        Maximum report range: 1 year
      </Stack>
      <Stack as="li">Data available: up to yesterday only</Stack>
    </Stack>
  </Copy>
);
